import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import FilterItems from 'pages/Configuration/FilterItems/FilterItems';

const ServiceOrderItem = ({ serviceOrderIdSelected }) => {

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingServiceOrderItemPanel, setLoadingServiceOrderItemPanel] = useState(null);
    const [recordsServiceOrderItemByUserId, setRecordsServiceOrderItemByUserId] = useState(null);
    const [attributesDetailServiceOrderItemPanel, setAttributesDetailServiceOrderItemPanel] = useState(null);
    const [servicesListNewRecord, setServicesListNewRecord] = useState(null);
    const [servicesListNewRecordSelected, setServicesListNewRecordSelected] = useState([]);

    const [serviceOrderItemIdSelected, setServiceOrderItemIdSelected] = useState([]);
    const [isActiveFilter, setIsActiveFilter] = useState('S');

    const readOnlyAttributes = !(inserting || updating);

    const [id, setId] = useState(null);
    const [serviceName, setServiceName] = useState(null);
    const [price, setPrice] = useState(null);
    const [timePerService, setTimePerService] = useState(null);
    const [isActive, setIsActive] = useState('S');

    const attributeList = [
        { name: "id", value: id, setter: setId },
        {
            name: "serviceName",
            value: serviceName,
            setter: setServiceName,
            readOnly: true
        },

        {
            name: "price",
            value: price,
            setter: setPrice,
        },

        {
            name: "timePerService",
            value: timePerService,
            setter: setTimePerService,
        },

        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                {
                    field: 'isActive',
                    condition: 'VALUE_EQUALS',
                    arrayValue: ['S']
                }
            ]
        }
    ];

    const attributeListDetail = [
        { name: "id", value: id, setter: setId, allowsMultipleRecordsSelected: true },
    ];

    useEffect(() => {
        reloadListServiceOrderItem();
        fetchDataDetailNewRecord();
        setServicesListNewRecordSelected([])
    }, [serviceOrderIdSelected]);

    useEffect(() => {
        reloadListServiceOrderItem();
    }, [isActiveFilter]);

    useEffect(() => {
        setInserting(false);
        setUpdating(false);
    }, [isActiveFilter]);

    useEffect(() => {
        setServicesListNewRecordSelected([])
    }, [inserting]);

    useEffect(() => {
        if (serviceOrderItemIdSelected && serviceOrderItemIdSelected.length === 1) {
            fetchDataDetail(serviceOrderItemIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }

    }, [serviceOrderItemIdSelected]);

    async function reloadListServiceOrderItem() {

        const items = await ExecuteAxios.api(
            'get',
            `/service-order-item/grid/`,
            {
                params: {
                    serviceOrderId: serviceOrderIdSelected[0],
                    isActive: isActiveFilter
                }
            }
        );

        setRecordsServiceOrderItemByUserId(items);

        RemoveIdsNotFound.remove(
            items,
            setServiceOrderItemIdSelected,
            serviceOrderItemIdSelected
        );
    }

    const fetchDataDetail = async (serviceOrderItemId) => {

        const item = await ExecuteAxios.api(
            'get',
            `/service-order-item/detail/`,
            {
                params: {
                    id: serviceOrderItemId || 0
                }
            }
        );

        if (item) {
            setAttributesDetailServiceOrderItemPanel(item);
            ApplyAttributes.applyAttributes(item, attributeList);
        }

        if (!serviceOrderItemId) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const fetchDataDetailNewRecord = async () => {

        const servicesListNewRecord = await ExecuteAxios.api(
            'get',
            `/service-order-item/list-services-for-insert/`
        );

        setServicesListNewRecord(servicesListNewRecord);
    };

    const getServiceOrderItemPanelListOrDetail = () => {

        if (inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setServicesListNewRecordSelected}
                    idsSelected={servicesListNewRecordSelected}
                    data={servicesListNewRecord}
                    attributeList={attributeListDetail}
                />
            );
        }

        if (updating) {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailServiceOrderItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            );

        }

        return (
            <PanelListDefault
                onUpdateIdSelected={setServiceOrderItemIdSelected}
                idsSelected={serviceOrderItemIdSelected}
                data={recordsServiceOrderItemByUserId}
                attributeList={attributeList}
            />
        );
    };

    async function postServiceOrderItem() {

        try {

            setLoadingServiceOrderItemPanel(true);

            const response = await ExecuteAxios.api(
                'post',
                `/service-order-item/`,
                {
                    serviceOrderId: serviceOrderIdSelected[0],
                    services: servicesListNewRecordSelected
                }
            );

            if (response) {
                await reloadListServiceOrderItem();
                setInserting(false);
            }

            return response;

        } finally {
            setLoadingServiceOrderItemPanel(false);
        }
    }

    async function putServiceOrderItem() {

        try {

            setLoadingServiceOrderItemPanel(true);

            const response = await ExecuteAxios.api(
                'put',
                `/service-order-item/`,
                {
                    id,
                    serviceOrderId: serviceOrderIdSelected[0],
                    isActive
                }
            );

            if (response) {
                await reloadListServiceOrderItem();
                setUpdating(false);
            }

            return response;

        } finally {
            setLoadingServiceOrderItemPanel(false);
        }
    }

    return (
        <Panel
            className={'main-modal'}
            style={{
                display: 'flex',
                flexDirection: 'column',
                marginLeft: '0px'
            }}
        >
            <LoadingIndicator loaded={!loadingServiceOrderItemPanel}>

                <FilterItems
                    isActiveFilter={isActiveFilter}
                    onUpdatesIsActiveFilter={setIsActiveFilter}
                />

                <Panel
                    titlePage={'Serviços'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canSaveAfterNewRecord={true}
                    canEdit={
                        serviceOrderItemIdSelected &&
                        serviceOrderItemIdSelected.length === 1
                    }
                    putFunction={putServiceOrderItem}
                    enableNewRecord={true}
                    canNewRecord={serviceOrderIdSelected.length > 0}
                    postFunction={postServiceOrderItem}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={serviceOrderItemIdSelected}
                    viewOnlyOneRecordCRUD={true}
                    resetVariables={() => {
                        ResetVariables.resetVariables(inserting ? attributeListDetail : attributeList);
                    }}
                    dataListedAttributes={inserting ? null : attributesDetailServiceOrderItemPanel}
                    attributeList={attributeListDetail}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    onUpdateIdSelected={setServiceOrderItemIdSelected}
                >
                    {getServiceOrderItemPanelListOrDetail()}
                </Panel>

            </LoadingIndicator>
        </Panel>
    );
};

export default ServiceOrderItem;
